import { useState } from "react";
import bgGif from "../assets/images/bg.gif";
import Input from "../components/Input";
import Textarea from "../components/Textarea";
import { useAuth } from "../hooks/useAuth";
import {
  checkAllMailAdmin,
  checkExistCustomerTestFile,
  checkingAllTab,
  downloadFile,
  slipCustom,
} from "../service/config.service";
import stringToArray from "../utils/stringToArray";
import { useEffect } from "react";

const ConfigPage = () => {
  const [adminFile, setAdminFile] = useState(null);
  const [customerFile, setCustomerFile] = useState(null);
  const [customerTestFile, setCustomerTestFile] = useState(null);
  const [contentFiles, setContentFiles] = useState([]);
  const [nameDisplays, setDisplayName] = useState("");
  const [subjects, setEmailSubjectInput] = useState("");
  const [links, setLinks] = useState("");
  const [numTabs, setNumTabs] = useState(10);
  const [message, setMessage] = useState("");
  const [tabsList, setTabsList] = useState([]);

  const [adminQuantity, setAdminQuantity] = useState(20);
  const [customerQuantity, setCustomerQuantity] = useState();
  const [nameDisplaysQuantity, setNameDisplaysQuantity] = useState(20);
  const [subjectsQuantity, setSubjectsQuantity] = useState(20);
  const [linksQuantity, setLinksQuantity] = useState();
  const [contentQuantity, setContentQuantity] = useState(20);

  const [messageCheckExistFile, setMessageCheckExistFile] = useState("");

  const { removeUser } = useAuth();

  useEffect(() => {
    const checkExistCustomer = async () => {
      try {
        const response = await checkExistCustomerTestFile();
        setMessageCheckExistFile(response.message);
      } catch (error) {
        console.log("Error checking customer test file:", error);
      }
    };
    checkExistCustomer();
  }, []);

  const handleDownload = async (url) => {
    try {
      console.log("Downloading file from:", url);
      await downloadFile(url);
    } catch (error) {
      console.error("Download error:", error);
      setMessage(error.response?.data?.error || "Lỗi khi tải file xuống");
    }
  };

  const handleSplit = async () => {
    if (!adminFile || !customerFile) {
      setMessage("Vui lòng chọn cả admin và customer file");
      return;
    }
    if (contentFiles.length === 0) {
      setMessage("Vui lòng chọn ít nhất 1 file nội dung thư");
      return;
    }
    if (!nameDisplays.trim() || !subjects.trim()) {
      setMessage("Vui lòng nhập tên hiển thị và tiêu đề email");
      return;
    }

    const winRefs = Array(numTabs)
      .fill()
      .map((_, i) => window.open("about:blank", `tab${i + 1}`));

    try {
      const formData = new FormData();
      formData.append("adminFile", adminFile);
      formData.append("customerFile", customerFile);
      if (customerTestFile) {
        formData.append("customerTestFile", customerTestFile);
      }
      contentFiles.forEach((file) => formData.append("contentFiles", file));
      formData.append("adminQuantity", adminQuantity);
      formData.append("customerQuantity", customerQuantity);
      formData.append("nameDisplaysQuantity", nameDisplaysQuantity);
      formData.append("subjectsQuantity", subjectsQuantity);
      formData.append("linksQuantity", linksQuantity);
      formData.append("contentQuantity", contentQuantity);

      const arrName = nameDisplays
        .split("\n")
        .map((s) => s.trim())
        .filter(Boolean);
      formData.append("nameDisplays", JSON.stringify(arrName));
      const arrSubj = subjects
        .split("\n")
        .map((s) => s.trim())
        .filter(Boolean);
      formData.append("subjects", JSON.stringify(arrSubj));
      const arrLinks = links
        .split("\n")
        .map((s) => s.trim())
        .filter(Boolean);
      formData.append("links", JSON.stringify(arrLinks));

      const resp = await slipCustom(numTabs, formData);

      setTabsList(resp.data);

      resp.data.forEach(({ tab }, i) => {
        const url = `${window.location.origin}/tab/${tab}`;
        if (winRefs[i] && !winRefs[i].closed) winRefs[i].location.href = url;
      });
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.error || "Lỗi khi chia tabs");
      winRefs.forEach((w) => w && !w.closed && w.close());
    }
  };

  const handleCheckAllAdmin = async () => {
    try {
      const resp = await checkAllMailAdmin();
      setMessage(resp.message);
    } catch (error) {
      setMessage(
        error.response?.data?.error || "Lỗi khi kiểm tra tất cả admin"
      );
    }
  };

  const handleCheckAll = async () => {
    try {
      const resp = await checkingAllTab();
      console.log(resp);

      setMessage(resp.message);
    } catch (error) {
      setMessage(
        error.response?.data?.error || "Lỗi khi kiểm tra tất cả admin"
      );
    }
  };

  const handleLogout = () => {
    removeUser();
    document.cookie = "token=; Max-Age=0";
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    window.location.href = "/";
  };

  const fileFields = [
    {
      label: "File mail admin",
      file: adminFile,
      onChange: (e) => setAdminFile(e.target.files[0]),
      accept: ".xlsx,.xls",
    },
    {
      label: "File khách hàng",
      file: customerFile,
      onChange: (e) => setCustomerFile(e.target.files[0]),
      accept: ".xlsx,.xls",
    },
    {
      label: "File test thư",
      file: customerTestFile,
      onChange: (e) => setCustomerTestFile(e.target.files[0]),
      accept: ".xlsx,.xls",
    },
    {
      label: "Nội dung thư",
      file: contentFiles,
      onChange: (e) => setContentFiles(Array.from(e.target.files)),
      accept: ".txt,.html",
      multiple: true,
    },
  ];

  return (
    <div className="relative min-h-screen before:absolute before:inset-0 before:bg-gradient-to-br before:from-purple-800 before:via-transparent before:to-indigo-900 before:opacity-60">
      <img
        src={bgGif}
        alt="bg"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="relative z-10 container mx-auto p-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Form */}
          <div className="lg:col-span-2 bg-white bg-opacity-80 backdrop-blur-lg rounded-3xl shadow-xl p-8 space-y-6">
            <h2 className="text-4xl font-extrabold text-indigo-700 text-center">
              Cấu hình
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
              {fileFields.map((f, i) => (
                <div key={i} className="flex flex-col">
                  <label className="text-sm font-medium text-gray-800 mb-2">
                    {f.label}
                    {f.multiple ? " (nhiều)" : ""}
                  </label>
                  <div
                    className={`bg-white p-1 overflow-y-auto cursor-pointer group relative 
                      border-2 border-dashed border-gray-300 rounded-lg h-16 flex 
                      ${
                        Array.isArray(f.file) ? "items-start" : "items-center"
                      } justify-center 
                      hover:border-indigo-500 transition`}
                  >
                    <input
                      type="file"
                      accept={f.accept}
                      multiple={f.multiple}
                      onChange={f.onChange}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    />
                    <div className="text-gray-500 group-hover:text-indigo-500 transition">
                      {f.file
                        ? Array.isArray(f.file)
                          ? f.file.map((file, idx) => (
                              <span key={idx}>{file.name},</span>
                            ))
                          : f.file.name
                        : f.label === "File test thư"
                        ? messageCheckExistFile
                        : "Chọn file"}
                    </div>
                  </div>
                </div>
              ))}
              <Input
                label=" Số lượng tab cần mở"
                type="number"
                placeholder="Số Tabs"
                value={numTabs}
                onChange={(e) => setNumTabs(+e.target.value)}
                classNameInput="w-24 border-gray-300 focus:ring-indigo-500 focus:border-transparent w-full h-full"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <Textarea
                label={`Tên hiển thị (Đang có: ${
                  stringToArray(nameDisplays).length
                })`}
                row={8}
                placeholder="Mỗi dòng 1"
                value={nameDisplays}
                onChange={(e) => setDisplayName(e.target.value)}
                classNameTextarea="border-gray-300 focus:ring-indigo-500 focus:border-transparent h-full"
              />
              <Textarea
                label={`Link đi kèm (Đang có: ${stringToArray(links).length})`}
                row={8}
                placeholder="Mỗi dòng 1"
                value={links}
                onChange={(e) => setLinks(e.target.value)}
                classNameTextarea="border-gray-300 focus:ring-indigo-500 focus:border-transparent h-full"
              />
              <Textarea
                label={`Tiêu đề Email (Đang có: ${
                  stringToArray(subjects).length
                })`}
                row={8}
                placeholder="Mỗi dòng 1"
                value={subjects}
                onChange={(e) => setEmailSubjectInput(e.target.value)}
                classNameTextarea="border-gray-300 focus:ring-indigo-500 focus:border-transparent h-full"
              />
              <div className="grid grid-cols-2 gap-4">
                {[
                  {
                    label: "Số lượng admin/tab",
                    value: adminQuantity,
                    placeholder: "Mặc định 10/tab",
                    onChange: (e) => setAdminQuantity(+e.target.value),
                  },
                  {
                    label: "Số lượng khách/tab",
                    value: customerQuantity,
                    placeholder: "Mặc định 3000/tab",
                    onChange: (e) => setCustomerQuantity(+e.target.value),
                  },
                  {
                    label: "Số lượng tên hiển thị/tab",
                    value: nameDisplaysQuantity,
                    placeholder: "Mặc định 10/tab",
                    onChange: (e) => setNameDisplaysQuantity(+e.target.value),
                  },
                  {
                    label: "Số lượng tiêu đề/tab",
                    value: subjectsQuantity,
                    placeholder: "Mặc định 10/tab",
                    onChange: (e) => setSubjectsQuantity(+e.target.value),
                  },
                  {
                    label: "Số lượng link/tab",
                    value: linksQuantity,
                    placeholder: "Mặc định 5/tab",
                    onChange: (e) => setLinksQuantity(+e.target.value),
                  },
                  {
                    label: "Số lượng nội dung/tab",
                    value: contentQuantity,
                    placeholder: "Mặc định 1/tab",
                    onChange: (e) => setContentQuantity(+e.target.value),
                  },
                ].map((inp, i) => (
                  <Input
                    key={i}
                    label={inp.label}
                    type="number"
                    min={1}
                    value={inp.value}
                    onChange={inp.onChange}
                    placeholder={inp.placeholder}
                    classNameInput="w-full border-gray-300 focus:ring-indigo-500 focus:border-transparent"
                  />
                ))}
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={handleSplit}
                className="flex-1 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-md transition transform hover:-translate-y-1"
              >
                Mở tab
              </button>
              <button
                onClick={handleCheckAllAdmin}
                className="flex-1 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-md transition transform hover:-translate-y-1"
              >
                Check tất cả admin
              </button>
              <button
                onClick={handleCheckAll}
                className="flex-1 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-md transition transform hover:-translate-y-1"
              >
                Check tất cả tab
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-md transition transform hover:-translate-y-1"
              >
                Logout
              </button>
            </div>
            {message && (
              <p className="text-center text-red-600 font-medium">{message}</p>
            )}
          </div>
          {/* Tabs */}
          <div className="bg-white bg-opacity-80 backdrop-blur-lg rounded-3xl shadow-xl p-6 h-full overflow-auto">
            <h3 className="text-2xl font-bold text-indigo-700 mb-4">
              Danh sách Tabs
            </h3>
            {tabsList.length > 0 ? (
              <ul className="space-y-4 max-h-[85vh] overflow-y-auto pr-2">
                {tabsList.map(({ tab, adminFileUrl, customerFileUrl }) => (
                  <li
                    key={tab}
                    className="p-4 bg-gray-50 rounded-lg border border-gray-200"
                  >
                    <p className="font-medium text-gray-700 truncate">{tab}</p>
                    <div className="mt-2 flex flex-wrap gap-2">
                      <a
                        href={`${window.location.origin}/tab/${tab}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-indigo-600 hover:underline"
                      >
                        Mở Tab
                      </a>
                      <button
                        onClick={() => handleDownload(adminFileUrl)}
                        className="text-green-600 hover:underline"
                      >
                        Tải Admin
                      </button>
                      <button
                        onClick={() => handleDownload(customerFileUrl)}
                        className="text-green-600 hover:underline"
                      >
                        Tải Customer
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 italic">Chưa có tabs để hiển thị</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigPage;
